<template>
  <div class="container">
    <div class="prize">
      <p v-if="money">
        <sub>￥</sub>
        <b>{{ !isNaN(parseFloat(money)) ? parseInt(money) : 0 }}</b>
        <sup>
          {{
            !isNaN(parseFloat(money)) && String(parseFloat(money)).indexOf('.') > -1
              ? String(parseFloat(money).toFixed(2)).slice(
                  String(parseFloat(money).toFixed(2)).indexOf('.'),
                  String(parseFloat(money).toFixed(2)).length
                )
              : '.00'
          }}
        </sup>
      </p>
      <span>爆款商品请尽快完成支付</span>
    </div>
    <div v-if="isWx">
      <van-radio-group v-model="wxRadio">
        <van-cell-group>
          <van-cell
            clickable
            @click="wxRadio = '1'"
            v-if="webWxpay && (isSwitch.web_wxpay == '1' || isSwitch.web_swiftwxpay == '1')"
          >
            <template slot="title" class="tit">
              <img src="../../assets/images/wxpay.png" />
              <div>微信</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="1" checked-color="#FC0324" />
            </div>
          </van-cell>
          <van-cell
            clickable
            @click="wxRadio = '2'"
            v-if="webUnionpay && isSwitch.web_unionpay == '1'"
          >
            <template slot="title" class="tit">
              <img src="../../assets/images/unionpay.png" />
              <div>银联</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="2" checked-color="#FC0324" />
            </div>
          </van-cell>
          <van-cell clickable @click="wxRadio = '3'" v-if="webJdpay && isSwitch.web_jdpay === '1'">
            <template slot="title" class="tit">
              <img src="../../assets/images/dpy.png" />
              <div>京东</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="3" checked-color="#FC0324" />
            </div>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div v-if="!isWx">
      <van-radio-group v-model="wapRadio">
        <van-cell-group>
          <van-cell
            clickable
            @click="wapRadio = '1'"
            v-if="webAlipay && isSwitch.web_alipay == '1'"
          >
            <template slot="title" class="tit">
              <img src="../../assets/images/pay_zfb.png" />
              <div>支付宝</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="1" checked-color="#FC0324" />
            </div>
          </van-cell>
          <van-cell
            clickable
            @click="wapRadio = '2'"
            v-if="webUnionpay && isSwitch.web_unionpay == '1'"
          >
            <template slot="title" class="tit">
              <img src="../../assets/images/unionpay.png" />
              <div>银联</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="2" checked-color="#FC0324" />
            </div>
          </van-cell>
          <van-cell clickable @click="wapRadio = '3'" v-if="webJdpay && isSwitch.web_jdpay === '1'">
            <template slot="title" class="tit">
              <img src="../../assets/images/dpy.png" />
              <div>京东</div>
            </template>
            <div slot="right-icon">
              <van-radio slot="icon" style="height: 100%" name="3" checked-color="#FC0324" />
            </div>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="paybtn" @click="pay">确定</div>
  </div>
</template>

<script>
import { RadioGroup, Radio } from 'vant'
import { isWeixin, appid, Base64, basepath, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'pay',
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  data() {
    return {
      money: this.$route.query.money ? this.$route.query.money : '0.00',
      wxRadio: '1',
      wapRadio: '1',
      webWxpay: false,
      webUnionpay: false,
      webAlipay: false,
      webJdpay: false,
      isSwitch: {},
      isWx: false,
      oid: this.$route.query.id ? this.$route.query.id : '',
      jumplink: '',
      virtualorderid: this.$route.query.virtualorderid ? this.$route.query.virtualorderid : '',
      isdeposit: this.$route.query.isdeposit ? this.$route.query.isdeposit : '',
      buyfrom: 0
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'pay' })
    }
    this.getData()
    this.jumplinkFn()
    if (isWeixin()) {
      this.isWx = true
      this.webWxpay = true
      this.webUnionpay = true
    } else {
      this.isWx = false
      this.webAlipay = true
      this.webUnionpay = true
    }
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    console.log(this.virtualorderid)
    if (this.virtualorderid) {
      let url = this.$ajax.cancelSupplementFreight_URL
      this.$customRequestAjax.post(url, { yforderid: this.virtualorderid }).then((res) => {
        if (res.data && res.data.code == 200) {
        }
      })
    }
    next()
  },
  methods: {
    groupQuery: function (extra) {
      var query = extra || {}
      if (this.$route.query.actgroupid) {
        query.actgroupid = this.$route.query.actgroupid
      }
      if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
        query.isShowIndex = this.$route.query.isShowIndex
      }
      if (this.$route.query.newpersonhide) {
        query.newpersonhide = this.$route.query.newpersonhide
      }
      return query
    },
    groupQueryStr: function () {
      var extra = []
      var q = this.$route.query
      if (q.actgroupid) extra.push('actgroupid=' + encodeURIComponent(q.actgroupid))
      if (q.isShowIndex == 0 || q.isShowIndex == 1) extra.push('isShowIndex=' + q.isShowIndex)
      if (q.newpersonhide) extra.push('newpersonhide=' + encodeURIComponent(q.newpersonhide))
      return extra.length ? '&' + extra.join('&') : ''
    },
    getData: function () {
      if (sessionStorage.getItem('pay_switch')) {
        this.isSwitch = JSON.parse(sessionStorage.getItem('pay_switch'))
      } else {
        var url = this.$ajax.getPayInfo_URL
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            this.isSwitch = res.data
            let skuidsArr = this.$route.query.skuids ? JSON.parse(this.$route.query.skuids) : [],
              skuids = ['1718', '1721', '2271', '2570']
            for (let i = 0; i < skuids.length; i++) {
              if (skuidsArr.indexOf(skuids[i]) > -1) {
                this.isSwitch.jumplink = ''
                break
              }
            }
          }
        })
      }
    },
    jumplinkFn: function () {
      var url = this.$ajax.getPresaleJump_URL + '?orderid=' + this.oid
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.jumplink = res.data.jumplink
        }
      })
    },
    pay() {
      this.$toast.loading({
        mask: true,
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      if (isWeixin()) {
        if (this.wxRadio == 1) {
          this.to_cash()
        } else if (this.wxRadio == 2) {
          this.to_cash_unionPay()
        } else {
          this.to_cash_dongPay()
        }
      } else {
        if (this.wapRadio == 1) {
          this.to_cash_otherPay()
        } else if (this.wapRadio == 2) {
          this.to_cash_unionPay()
        } else {
          this.to_cash_dongPay()
        }
      }
    },
    /*
     * 调用微信JS api 支付
     */
    jsApiCall(d) {
      var that = this
      WeixinJSBridge.invoke('getBrandWCPayRequest', d, function (res) {
        WeixinJSBridge.log(res.err_msg)
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          // that.$toast('支付成功')
          if (sessionStorage.getItem('unpaypopup-pay') == that.oid) {
            that.$clickburiedPoint({
              data: {
                buttonCode: 'unpaypopup-pay',
                buttontext: sessionStorage.getItem('unpaypopup-pay')
              }
            })
          }
          sessionStorage.removeItem('unpaypopup-pay')
          setTimeout(function () {
            if (that.$route.query.getcoupon == 1) {
              window.location =
                basepath + '/static/wx/html/20190820/buyCoupon/paySuccess.html?orderId=' + that.oid
            } else {
              if (that.isSwitch.jumplink) {
                window.location = that.isSwitch.jumplink
                return
              }
              if (that.jumplink) {
                //   window.location = that.jumplink
                that.$app.argStaticLink(
                  that.jumplink +
                    (that.jumplink.indexOf('?') >= 0 ? '&' : '?' + 'orderid=' + that.oid)
                )
                return
              }
              if (that.$route.query.pathType == 'newpro') {
                that.$router.replace({
                  path: '/orderdetails',
                  query: {
                    id: that.oid,
                    receivestatus: encodeURIComponent('success')
                  }
                })
              } else {
                that.$router.replace({
                  path: '/payResult',
                  query: that.groupQuery({
                    id: that.oid,
                    money: parseFloat(that.money).toFixed(2),
                    payresult: encodeURIComponent('success'),
                    yl: that.$route.query.yl || 0,
                    ms: that.$route.query.ms || 0,
                    lb: that.$route.query.lb || 0,
                    ylcc: that.$route.query.ylcc || 0,
                    ann: that.$route.query.ann || 0,
                    anncc: that.$route.query.anncc || 0,
                    isdeposit: that.isdeposit,
                    sourcePage: 'pay'
                  })
                })
              }
            }
          }, 1000)
        } else if (
          res.err_msg == 'get_brand_wcpay_request:cancel' ||
          res.err_msg == 'get_brand_wcpay_request:fail'
        ) {
          console.log(that.virtualorderid)
          if (that.virtualorderid) {
            let url = that.$ajax.cancelSupplementFreight_URL
            that.$customRequestAjax.post(url, { yforderid: that.virtualorderid }).then((res) => {
              if (res.data && res.data.code == 200) {
              }
            })
            window.location.replace(localStorage.getItem('currentAddress'))
          } else if (that.$route.query.getcoupon == 1) {
          } else {
            if (that.isdeposit) {
              that.$toast('支付失败')
            } else {
              if (that.$route.query.pathType != 'newpro') {
                that.$router.replace({
                  path: '/payResult',
                  query: that.groupQuery({
                    id: that.oid,
                    money: parseFloat(that.money).toFixed(2),
                    payresult: encodeURIComponent('failure'),
                    yl: that.$route.query.yl || 0,
                    ms: that.$route.query.ms || 0,
                    lb: that.$route.query.lb || 0,
                    ylcc: that.$route.query.ylcc || 0,
                    ann: that.$route.query.ann || 0,
                    anncc: that.$route.query.anncc || 0
                  })
                })
              }
            }
          }
        }
      })
    },
    /*
     * 微信支付
     */
    to_cash() {
      let url, data

      url = this.$ajax.check_order_status_URL
      data = {
        oid: this.oid
      }

      if (this.isdeposit) {
        let info = {
          order_status: 1
        }
        this.getPayInfo(info)
      } else {
        this.checkOrder(url, data)
      }
    },
    // 检查订单状态
    checkOrder(url, data) {
      let that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data && res.data.code == 200) {
          that.buyfrom = res.data.buyfrom
          that.getPayInfo(res.data)
        }
      })
    },
    getPayInfo(info) {
      let that = this,
        phpUrl,
        phpData

      if (info.order_status == 1 || (info.order_status == 2 && !!this.virtualorderid)) {
        if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
          phpUrl = that.$ajax.weixin_wxpay2_URL
          if (that.isSwitch.wx_paytype == 1) {
            phpUrl = that.$ajax.weixinnet_wxpay2_URL
          }
        } else if (that.isSwitch.web_wxpay == '1') {
          phpUrl = that.$ajax.weixin_wxpay2_URL
          if (that.isSwitch.wx_paytype == 1) {
            phpUrl = that.$ajax.weixinnet_wxpay2_URL
          }
        } else if (that.isSwitch.web_swiftwxpay == '1') {
          phpUrl = that.$ajax.swiftpass_pay_URL
        }

        phpData = {
          openid: appid
        }
        if (that.virtualorderid) {
          phpData.yforderid = that.virtualorderid
        } else {
          phpData.orderId = that.oid
        }
        // if (that.buyfrom == 5) phpData.payclient = 'small'
        that.$customRequestAjax.post(phpUrl, phpData).then((res) => {
          if (res.data && res.data.code == 200) {
            that.$toast.clear()
            if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
              that.callpay(JSON.parse(res.data.jsApiParameters))
            } else if (that.isSwitch.web_wxpay == '1') {
              that.callpay(JSON.parse(res.data.jsApiParameters))
            } else if (that.isSwitch.web_swiftwxpay == '1') {
              that.callpay(JSON.parse(res.data.codeinfo))
            }
          } else {
            that.$toast(res.data.codeinfo)
          }
        })
      } else {
        that.$toast(info.codeinfo)
        setTimeout(function () {
          that.$router.push('/')
        }, 1000)
      }
    },
    /*
     * 微信支付调用
     */
    callpay(d) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall(d)
      }
    },
    /*
     * 支付宝支付
     */
    to_cash_otherPay() {
      var base = new Base64()
      // console.log(base.encode(localStorage.getItem('currentAddress')))
      this.$toast.clear()
      var virtualorderid = this.virtualorderid
      if (!!virtualorderid) {
        if (this.isSwitch.jumplink) {
          window.location.href =
            basepath +
            'pay/wxmall_pay/alipay/wappay/pay.php?yforderid=' +
            virtualorderid +
            '&callback=' +
            base.encode(this.isSwitch.jumplink)
          return
        }
        if (this.jumplink) {
          window.location.href =
            basepath +
            'pay/wxmall_pay/alipay/wappay/pay.php?yforderid=' +
            virtualorderid +
            '&callback=' +
            base.encode(this.jumplink)
          return
        }
        window.location.href =
          basepath +
          'pay/wxmall_pay/alipay/wappay/pay.php?yforderid=' +
          virtualorderid +
          '&callback=' +
          base.encode(
            basepath +
              '/payResult?payresult=' +
              encodeURIComponent('success') +
              '&id=' +
              this.oid +
              '&money=' +
              parseFloat(this.money).toFixed(2) +
              this.groupQueryStr()
          )
      } else if (this.$route.query.getcoupon == 1) {
        window.location.href =
          basepath +
          'pay/wxmall_pay/alipay/wappay/pay.php?orderId=' +
          this.oid +
          '&callback=' +
          base.encode(
            basepath + '/static/wx/html/20190820/buyCoupon/paySuccess.html?orderId=' + this.oid
          )
      } else {
        if (this.isSwitch.jumplink) {
          window.location.href =
            basepath +
            'pay/wxmall_pay/alipay/wappay/pay.php?orderId=' +
            this.oid +
            '&type=' +
            (this.$route.query.integralType && this.$route.query.integralType == 1
              ? 'integral'
              : '') +
            '&callback=' +
            base.encode(this.isSwitch.jumplink)
          return
        }
        if (this.jumplink) {
          window.location.href =
            basepath +
            'pay/wxmall_pay/alipay/wappay/pay.php?orderId=' +
            this.oid +
            '&type=' +
            (this.$route.query.integralType && this.$route.query.integralType == 1
              ? 'integral'
              : '') +
            '&callback=' +
            base.encode(this.jumplink)
          return
        }
        window.location.href =
          basepath +
          'pay/wxmall_pay/alipay/wappay/pay.php?orderId=' +
          this.oid +
          '&type=' +
          (this.$route.query.integralType && this.$route.query.integralType == 1
            ? 'integral'
            : '') +
          '&callback=' +
          base.encode(
            basepath +
              '/payResult?payresult=' +
              encodeURIComponent('success') +
              '&id=' +
              this.oid +
              '&money=' +
              parseFloat(this.money).toFixed(2) +
              this.groupQueryStr()
          )
      }
    },
    /*
     * 银联支付
     */
    to_cash_unionPay() {
      var base = new Base64()
      var url = this.$ajax.check_order_status_URL
      var data = {
        oid: this.oid
      }
      var that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data && res.data.code == 200) {
          if (res.data.order_status == 1 || (res.data.order_status == 2 && !!that.virtualorderid)) {
            that.$toast.clear()
            if (!!that.virtualorderid) {
              if (this.isSwitch.jumplink) {
                window.location =
                  basepath +
                  'pay/wxmall_pay/unionpay/pages/payinfo.php?yforderid=' +
                  that.virtualorderid +
                  '&callback=' +
                  base.encode(this.isSwitch.jumplink)
                return
              }
              if (this.jumplink) {
                window.location =
                  basepath +
                  'pay/wxmall_pay/unionpay/pages/payinfo.php?yforderid=' +
                  that.virtualorderid +
                  '&callback=' +
                  base.encode(this.jumplink)
                return
              }
              window.location =
                basepath +
                'pay/wxmall_pay/unionpay/pages/payinfo.php?yforderid=' +
                that.virtualorderid +
                '&callback=' +
                base.encode(
                  basepath +
                    '/payResult?payresult=' +
                    encodeURIComponent('success') +
                    '&id=' +
                    this.oid +
                    '&money=' +
                    parseFloat(this.money).toFixed(2) +
                    this.groupQueryStr()
                )
            } else if (this.$route.query.getcoupon == 1) {
              window.location =
                basepath +
                'pay/wxmall_pay/unionpay/pages/payinfo.php?orderId=' +
                that.oid +
                '&callback=' +
                base.encode(
                  basepath +
                    '/static/wx/html/20190820/buyCoupon/paySuccess.html?orderId=' +
                    that.oid +
                    '&money=' +
                    parseFloat(this.money).toFixed(2)
                )
            } else {
              if (this.isSwitch.jumplink) {
                window.location =
                  basepath +
                  'pay/wxmall_pay/unionpay/pages/payinfo.php?orderId=' +
                  that.oid +
                  '&callback=' +
                  base.encode(this.isSwitch.jumplink)
                return
              }
              if (this.jumplink) {
                window.location =
                  basepath +
                  'pay/wxmall_pay/unionpay/pages/payinfo.php?orderId=' +
                  that.oid +
                  '&callback=' +
                  base.encode(this.jumplink)
                return
              }
              window.location =
                basepath +
                'pay/wxmall_pay/unionpay/pages/payinfo.php?orderId=' +
                that.oid +
                '&callback=' +
                base.encode(
                  basepath +
                    '/payResult?payresult=' +
                    encodeURIComponent('success') +
                    '&id=' +
                    that.oid +
                    '&money=' +
                    parseFloat(this.money).toFixed(2) +
                    this.groupQueryStr()
                )
            }
          } else {
            that.$toast(data.codeinfo)
            setTimeout(function () {
              that.$router.push('/')
            }, 1000)
          }
        }
      })
    },
    to_cash_dongPay() {
      var base = new Base64()
      this.$toast.clear()
      if (this.virtualorderid) {
        if (this.isSwitch.jumplink) {
          window.location.href =
            basepath +
            'pay/appmall_pay/jdpay/action/apph5.php?yforderid=' +
            this.virtualorderid +
            '&callback=' +
            base.encode(this.isSwitch.jumplink)
          return
        }
        if (this.jumplink) {
          window.location.href =
            basepath +
            'pay/appmall_pay/jdpay/action/apph5.php?yforderid=' +
            this.virtualorderid +
            '&callback=' +
            base.encode(this.jumplink)
          return
        }
        window.location.href =
          basepath +
          'pay/appmall_pay/jdpay/action/apph5.php?yforderid=' +
          this.virtualorderid +
          '&callback=' +
          base.encode(
            basepath +
              '/payResult?payresult=' +
              encodeURIComponent('success') +
              '&id=' +
              this.oid +
              '&money=' +
              parseFloat(this.money).toFixed(2) +
              this.groupQueryStr()
          )
      } else if (this.$route.query.getcoupon == 1) {
        window.location.href =
          basepath +
          'pay/appmall_pay/jdpay/action/apph5.php?orderId=' +
          this.oid +
          '&callback=' +
          base.encode(
            basepath +
              '/static/wx/html/20190820/buyCoupon/paySuccess.html?orderId=' +
              this.oid +
              '&money=' +
              parseFloat(this.money).toFixed(2)
          )
      } else {
        if (this.isSwitch.jumplink) {
          window.location.href =
            basepath +
            'pay/appmall_pay/jdpay/action/apph5.php?orderId=' +
            this.oid +
            '&callback=' +
            base.encode(this.isSwitch.jumplink)
          return
        }
        if (this.jumplink) {
          window.location.href =
            basepath +
            'pay/appmall_pay/jdpay/action/apph5.php?orderId=' +
            this.oid +
            '&callback=' +
            base.encode(this.jumplink)
          return
        }
        window.location.href =
          basepath +
          'pay/appmall_pay/jdpay/action/apph5.php?orderId=' +
          this.oid +
          '&callback=' +
          base.encode(
            basepath +
              '/payResult?payresult=' +
              encodeURIComponent('success') +
              '&id=' +
              this.oid +
              '&money=' +
              parseFloat(this.money).toFixed(2) +
              this.groupQueryStr()
          )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
  position: absolute;
  height: 100%;
  width: 100%;
  .prize {
    /*height: 1.015rem;*/
    font-size: 0;
    text-align: center;
    border-bottom: 0.1rem solid #eeeeee;
    p {
      padding-top: 0.24rem;
      color: #fc0424;
      margin-bottom: 0.11rem;
    }
    sub {
      font-size: 0.24rem;
      line-height: 0.24rem;
    }
    b {
      font-size: 0.36rem;
      line-height: 0.24rem;
      font-weight: 500;
    }
    sup {
      font-size: 0.24rem;
      line-height: 0.24rem;
    }
    span {
      font-size: 0.14rem;
      font-weight: normal;
      color: rgba(68, 68, 68, 1);
      line-height: 0.185rem;
      display: block;
      padding-bottom: 0.24rem;
    }
  }
  .van-cell {
    padding: 0.15rem;
  }
  .van-cell__title {
    margin-left: 0.21rem;
    line-height: 0.3rem;
    img {
      width: 0.3rem;
      height: 0.3rem;
      display: block;
      float: left;
    }
    div {
      font-size: 0.13rem;
      color: #333;
      float: left;
      margin-left: 0.15rem;
    }
  }
  .van-cell:not(:last-child)::after {
    border-color: #d8d8d8;
    right: 0.16rem;
  }
  .van-cell:last-child::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #d8d8d8;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .paybtn {
    width: 3.53rem;
    height: 0.43rem;
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    border-radius: 0.25rem;
    line-height: 0.43rem;
    font-size: 0.17rem;
    color: #fff;
    position: fixed;
    bottom: 0.11rem;
    left: 0.11rem;
    right: 0.11rem;
    text-align: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/pay.vue